import React, {Component} from "react";
import PropTypes from "prop-types";
import {Redirect} from 'react-router';
import {NavLink} from 'react-router-dom';
import Loader from '../Loader'
import api from "../../api/Api";

import ReactTable from "react-table";
import "react-table/react-table.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Datetime from "react-datetime";
import moment from "moment";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// core components
import GridItem from "components/Grid/GridItem.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import matchSorter from 'match-sorter';
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import LocalHospital from "@material-ui/icons/LocalHospital";
import SearchComponent from "components/Search/AutoCompletePatient.jsx";

//import AlertBox from 'components/AlertBox/alertbox.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import GridContainer from "components/Grid/GridContainer.jsx";

import {
    mappingUI,
    dashboardRouter,
    isClinicMasterOrClinic,
    getClinicUserId, getDateConverter,
    getReportTypes
} from '../../util/globalHelper';
import Permissions from '../../util/globalPermissions';
const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    AutoCompleteClass: {
        width: '100%',
        padding: 0,
        margin: '20px 0',
        height: 0,
        position: 'inherit'
    }
};
class JDLeadsList extends Component {
    constructor() {
        super();
        this.state = {
            data: null,
            clinicsData: null,
            simpleSelect: "",
            doctorsData: null,
            start_date: "",
            end_date: "",
            clinic_id: "",
            doctor_id: "",
            patientId: "",
            type: "",
            open: true,
            alert: null,
            status: "",
            comments: "",
            smsMessage: "",
        };
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.searchOnFilter = this.searchOnFilter.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
        this.CreateAlert = this.CreateAlert.bind(this)
        this.onChangeStatus = this.onChangeStatus.bind(this)
        this.changeStatusApi = this.changeStatusApi.bind(this)
    }

    handleChangeStartDate(event) {
        this.setState({start_date: event.format('YYYY-MM-DD')});
    }

    handleChangeEndDate(event) {
        this.setState({end_date: event.format('YYYY-MM-DD')});
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    CallReadApi = () => {
        api.getAllLeads({})
            .then(json => {
                this.setState({data: json.data.data})
            });

    }

    componentDidMount() {
        this.CallReadApi();
    }

    searchOnFilter() {
        this.setState({data: null})
        var postBody = {
            clinic_id: this.state.clinic_id,
            patient_id: this.state.patientId,
            doctor_id: this.state.doctor_id,
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            type: this.state.simpleSelect
        }
        api.getReportList(postBody)
            .then(json => {
                this.setState({data: json.data.data})
            });
    }


    getSuggestionValue = (suggestion) => {
        this.setState({
            patientId: suggestion._id,

        });
        return suggestion.user_id.name


    };

    hideAlert() {
        this.setState({alert: null})
    }

    CreateAlert(id) {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{"Change Status"}</DialogTitle>
                    <div style={{padding: '0 20px'}}>
                        <h6>Select Status:</h6>
                        <input type="radio" onChange={this.onChangeStatus}
                            // checked={this.state.status === "Follow up"}
                               value={"Follow up"} name="status"/>Follow up<br/>
                        <input type="radio" onChange={this.onChangeStatus} name="status"
                            // checked={this.state.status === "Accepted"}
                               value={"Accepted"}/>Accepted<br/>
                        <input type="radio" onChange={this.onChangeStatus} name="status"
                            // checked={this.state.status === "Rejected"}
                               value={"Rejected"}/>Rejected<br/>

                        <h6>Comments:</h6>
                        <textarea name="comments"
                                  onChange={e => this.setState({comments: e.target.value})}/>

                    </div>
                    <DialogActions style={{margin: '8px auto'}}>
                        <Button color="info" onClick={() => {
                            this.changeStatusApi(id)
                        }}>
                            Change
                        </Button>
                        <Button onClick={this.hideAlert}>
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        });
    }

    deleteRecord(id) {
        var postBody = {"_id": id, "updated_object": {}};
        api.deleteReport(postBody)
            .then(json => {
                window.location.reload();
            });
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    render() {
        const {data, clinicsData, doctorsData} = this.state;
        const {classes} = this.props;
        if (this.state.data !== null)
            return (
                <div>
                    {this.state.alert}
                    <Grid container>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <LocalHospital style={{marginTop: 10}}/>
                                            </GridItem>

                                            <GridItem>
                                                <h4 className={classes.cardTitleWhite}>Just Dial</h4>
                                                <p className={classes.cardCategoryWhite}>
                                                    List of all leads
                                                </p>
                                            </GridItem>
                                        </GridContainer>
                                    </CardText>
                                </CardHeader>
                                <CardBody>
                                    <br/>
                                    {data.length >= 0 ?
                                        <ReactTable
                                            data={data}
                                            filterable
                                            defaultFilterMethod={(filter, row) =>
                                            String(row[filter.id]) === filter.value}
                                            columns={[
                                                {
                                                    columns: [
                                                        {
                                                            Header: "Name",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p style={{cursor: 'pointer'}}>
                                                                            {data[index].lead_details ? data[index].lead_details.name : "No Name"}
                                                                        </p>
                                                                    </div>
                                                                ),
                                                        },
                                                        {
                                                            Header: "Contact",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{data[index].lead_details ? data[index].lead_details.mobile : "No Mobile"}</p>
                                                                    </div>
                                                                ),

                                                        },
                                                        {
                                                            Header: "Requirement",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{data[index].lead_details ? data[index].lead_details.category : "No Category"}</p>

                                                                    </div>
                                                                ),

                                                        },
                                                        {
                                                            Header: "Area",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{data[index].lead_details ? `${data[index].lead_details.area} ,${data[index].lead_details.city}` : "No Area"}</p>

                                                                    </div>
                                                                ),

                                                        },
                                                        {
                                                            Header: "Date/Time",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{data[index].lead_details ? data[index].lead_details.date : "No Date"}</p>

                                                                    </div>
                                                                ),

                                                        },
                                                        {
                                                            Header: "Status",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{data[index] ? data[index].status : "-"}</p>

                                                                    </div>
                                                                ),

                                                        },
                                                        {
                                                            Header: "Remarks",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{data[index] ? data[index].notes : "-"}</p>

                                                                    </div>
                                                                ),

                                                        },
                                                        {
                                                            Header: 'Actions',
                                                            id: 'request_state',
                                                            filterable: false,
                                                            sortable: false,
                                                            Cell: ({index}) =>
                                                                (<div>

                                                                    <Button onClick={() => {
                                                                        this.CreateAlert(data[index]._id)
                                                                    }} type="button" color="info"
                                                                            style={{
                                                                                padding: 8,
                                                                                paddingLeft: 21,
                                                                                paddingRight: 21
                                                                            }}>
                                                                        Change Status
                                                                    </Button><br/> <NavLink
                                                                    to={dashboardRouter(`/appointment/bookAppointment?name=${data[index].lead_details.name}&mobile=${data[index].lead_details.mobile}`)}><Button type="button" color="success"
                                                                                           style={{
                                                                                               padding: 8,
                                                                                           }}>
                                                                    Book Appointment
                                                                </Button></NavLink>
                                                                    <br/> <Button onClick={() => {
                                                                    this.CreateSMSAlert(data[index].lead_details.mobile)
                                                                }} type="button" color="warning"
                                                                                  style={{
                                                                                      padding: 8,
                                                                                      paddingLeft: 23,
                                                                                      paddingRight: 23
                                                                                  }}>
                                                                    Send Message
                                                                </Button>
                                                                </div>)
                                                        }]
                                                }
                                            ]}
                                            defaultPageSize={10}
                                            className="-striped -highlight"
                                        />
                                        : null}
                                </CardBody>
                            </Card>
                        </GridItem>
                    </Grid>
                </div>
            );
        else return (
            <div>
                <Loader/>
            </div>
        )
    }

    onChangeStatus(e) {
        this.setState({status: e.target.value})
    }

    changeStatusApi(id) {
        var postBody = {
            "_id": id, "updated_object": {
                "status": this.state.status,
                "notes": this.state.comments
            }
        };
        api.updateLead(postBody).then(json => {
            this.setState({status: "", comments: "", alert: null})
            api.getAllLeads({})
                .then(json => {
                    this.setState({data: json.data.data})
                });
        });
    }

    sendSMSApi(number) {
        var postBody = {
            "contact": number,
            "message": this.state.smsMessage
        };
        if(this.state.smsMessage!=="")
        api.sendCustomMessage(postBody).then(json => {
            this.setState({status: "", comments: "", alert: null})
        });
    }

    CreateSMSAlert(id) {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{"Send SMS"}</DialogTitle>
                    <div style={{padding: '0 20px'}}>
                        <textarea style={{width:'180px'}} name="smsMessage"
                                  onChange={e => this.setState({smsMessage: e.target.value})}/>

                    </div>
                    <DialogActions style={{margin: '8px auto'}}>
                        <Button color="info" onClick={() => {
                            this.sendSMSApi(id)
                        }}>
                            Send
                        </Button>
                        <Button onClick={this.hideAlert}>
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        });
    }
}
export default withStyles(styles)(JDLeadsList);



// WEBPACK FOOTER //
// ./src/components/Marketing/JDLeadsList.jsx